module.exports = __webpack_public_path__ + "img/email.589f7f1e.svg";